import React, { useEffect, useState } from 'react';
import { countdown } from '../../utils/surfaceFormat';

/**
 * Live countdown text. Ticks every second for the clock style, every 30s otherwise.
 * Renders `expiredText` once the target passes and calls onExpire once.
 */
export default function Countdown({ to, style = 'short', suffix = '', expiredText = 'NOW', onExpire, className = '', as: Tag = 'span', ...rest }) {
  const [now, setNow] = useState(() => new Date());
  useEffect(() => {
    const ms = style === 'clock' ? 1000 : 30000;
    const id = window.setInterval(() => setNow(new Date()), ms);
    return () => window.clearInterval(id);
  }, [style]);
  const c = countdown(to, { style, now });
  useEffect(() => {
    if (c.expired && to) onExpire?.();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [c.expired]);
  return <Tag className={className} {...rest}>{c.expired ? expiredText : `${c.text}${suffix}`}</Tag>;
}
